import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { Group } from '../domain/dtos/whitelist'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class GetGroup {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(id: string): Promise<Group> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/group/get/pt`,
      body: { data: { id } },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data.result.group
    }

    throw new GeneralError()
  }
}
